module.exports = __webpack_public_path__ + "img/lee_icon.93360a2e.png";